import React from "react"

export const CanadianFlag = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2527_135725)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M24.0008 12.0012C24.0008 7.24364 21.2322 3.13289 17.2182 1.19189V22.8104C21.2322 20.8695 24.0008 16.7587 24.0008 12.0012Z"
        fill="#D80027"
      />
      <path
        d="M0.000453949 12.0004C0.000453949 16.758 2.76913 20.8687 6.78308 22.8097V1.19116C2.76913 3.13216 0.000453949 7.24291 0.000453949 12.0004Z"
        fill="#D80027"
      />
      <path
        d="M14.0875 13.5663L16.1745 12.5228L15.131 12.001V10.9576L13.0441 12.001L14.0875 9.91408H13.0441L12.0006 8.34888L10.9571 9.91408H9.9136L10.9571 12.001L8.87011 10.9576V12.001L7.82668 12.5228L9.9136 13.5663L9.39188 14.6097H11.4788V16.1749H12.5223V14.6097H14.6093L14.0875 13.5663Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_2527_135725">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const NigerianFlag = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2527_135703)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M-0.000408173 12.0001C-0.000408173 17.1598 3.25609 21.5582 7.8257 23.2538V0.746582C3.25609 2.44205 -0.000408173 6.84061 -0.000408173 12.0001Z"
        fill="#6DA544"
      />
      <path
        d="M23.9999 12.0001C23.9999 6.84061 20.7434 2.44205 16.1738 0.746582V23.2538C20.7434 21.5582 23.9999 17.1598 23.9999 12.0001Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_2527_135703">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const USFlag = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2527_135682)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.4779 12.0001H23.9997C23.9997 10.917 23.8553 9.86774 23.5863 8.86963H11.4779V12.0001Z"
        fill="#D80027"
      />
      <path
        d="M11.4779 5.73861H22.2384C21.5038 4.53992 20.5646 3.4804 19.4695 2.60815H11.4779V5.73861Z"
        fill="#D80027"
      />
      <path
        d="M11.9997 24C14.8239 24 17.4197 23.0239 19.4695 21.3914H4.5299C6.57975 23.0239 9.17554 24 11.9997 24Z"
        fill="#D80027"
      />
      <path
        d="M1.76106 18.2601H22.2385C22.8282 17.2978 23.2856 16.2459 23.5864 15.1296H0.413166C0.713963 16.2459 1.17132 17.2978 1.76106 18.2601Z"
        fill="#D80027"
      />
      <path
        d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2527_135682">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const SAFlag = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2527_135746)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.51425 20.4853C-1.17203 15.7989 -1.17203 8.20098 3.51425 3.51465C3.51392 3.51516 10.4344 12 10.4344 12L3.51425 20.4853Z"
        fill="black"
      />
      <path
        d="M10.435 12.0001L1.59171 6.02417C1.31754 6.50075 1.07576 6.99819 0.868008 7.51306L5.34499 12.0002L0.868148 16.4875C1.07571 17.002 1.31726 17.4991 1.59124 17.9754L10.435 12.0001Z"
        fill="#FFDA44"
      />
      <path
        d="M23.8986 10.4348H10.4346L3.51476 3.51489C2.76907 4.26058 2.12121 5.10391 1.59171 6.02411L7.55604 12L1.59124 17.9752C2.12074 18.8956 2.76888 19.7392 3.51476 20.4851L10.4346 13.5652H23.8986C23.9653 13.0529 24.0002 12.5305 24.0002 12C24.0002 11.4695 23.9653 10.9472 23.8986 10.4348Z"
        fill="#6DA544"
      />
      <path
        d="M4.6937 21.5182C6.71724 23.0736 9.25023 23.9989 11.9997 23.9989C17.5441 23.9989 22.2093 20.2386 23.5863 15.1294H11.0825L4.6937 21.5182Z"
        fill="#0052B4"
      />
      <path
        d="M23.5863 8.86881C22.2093 3.75963 17.5441 -0.000732422 11.9997 -0.000732422C9.25023 -0.000732422 6.71724 0.924627 4.6937 2.48003L11.0825 8.86881H23.5863Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_2527_135746">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
